import React from 'react';
import { Section, FadeIn } from './ui';
export const SolutionSection = () => {
  return <Section className="bg-white" data-id="element-219">
      <FadeIn data-id="element-220">
        <div className="text-center mb-6 sm:mb-12" data-id="element-221">
          <span className="text-rose-500 font-medium tracking-widest uppercase text-sm mb-2 sm:mb-4 block" data-id="element-222">
            La Solución
          </span>
        </div>

        <div className="bg-navy-900 rounded-2xl sm:rounded-3xl p-6 sm:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-223">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber-400 via-rose-400 to-amber-400" data-id="element-224"></div>

          <h2 className="text-3xl sm:text-5xl md:text-6xl font-serif text-cream-100 mb-4 sm:mb-6 leading-tight" data-id="element-225">
            SIEMPRE PARA TODOS,
            <br data-id="element-226" />
            <span className="text-amber-400 italic" data-id="element-227">NUNCA PARA MÍ</span>
          </h2>

          <p className="text-lg sm:text-2xl text-cream-100/90 font-light max-w-2xl mx-auto mb-4 sm:mb-8" data-id="element-228">
            Guía de Recuperación Emocional para la Mujer que ya No Puede Más
          </p>

          <div className="text-2xl sm:text-3xl" data-id="element-229">🌸</div>
        </div>

        <div className="mt-8 sm:mt-16 max-w-2xl mx-auto text-center space-y-3 sm:space-y-6 text-base sm:text-xl text-gray-700" data-id="element-230">
          <p data-id="element-231">Este no es un libro de frases bonitas.</p>
          <p data-id="element-232">No te va a decir que "sonrías más" o que "pienses positivo."</p>
          <p className="font-medium text-navy-900" data-id="element-233">
            Es una conversación honesta entre dos mujeres.
          </p>
          <p data-id="element-234">
            Una que entiende exactamente el peso que cargas. Y un mapa real para
            que dejes de cargarlo sola.
          </p>
        </div>
      </FadeIn>
    </Section>;
};